/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/** contact-controller */
import { http } from '@/services/api/http';
import { RequestOptions } from '@/services/api/types';
import type * as model from './models';

/** contact-controller listContactEmails */
export async function listContactEmailsGet(
  payload: {
    cursor?: string;
    size?: number;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiCursorPageableResultSourcingContactEmail>({
    url: `/es/api/biz/contact`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** contact-controller toggleAutoReply */
export async function toggleAutoReplyPut(
  payload: {
    contactId: number;
    enabled: number;
  },
  options?: RequestOptions
) {
  const params = Object.assign({}, { enabled: payload.enabled });

  const result = await http.request<model.IApiJsonResultVoid>({
    url: `/es/api/biz/contact/auto-reply/${payload.contactId}`,
    method: 'put',
    params,
    ...options,
  });

  return result.data;
}

/** contact-controller pinToTop */
export async function pinToTopPut(
  payload: {
    id: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiResultCode>({
    url: `/es/api/biz/contact/pin-top`,
    method: 'put',
    params,
    ...options,
  });

  return result.data;
}

/** contact-controller unpin */
export async function unpinPut(
  payload: {
    id: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiResultCode>({
    url: `/es/api/biz/contact/unpin`,
    method: 'put',
    params,
    ...options,
  });

  return result.data;
}

/** contact-controller unread */
export async function unreadPost(payload: model.IApiContactUnreadReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<Array<model.IApiContactUnreadResp>>({
    url: `/es/api/biz/contact/unread`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** contact-controller getContactEmail */
export async function getContactEmailGet(
  payload: {
    contactId: string;
  },
  options?: RequestOptions
) {
  const result = await http.request<model.IApiSourcingContactEmail>({
    url: `/es/api/biz/contact/${payload.contactId}`,
    method: 'get',
    ...options,
  });

  return result.data;
}
